import type { RouteRecordRaw } from 'vue-router'

import bouyguesInStoreRoutes from './flows/bouygues-in-store/routes'
import eCommerceRoutes from './flows/e-commerce/routes'
import giftCardRoutes from './flows/gift-card/routes'

export default (): RouteRecordRaw[] => {
  return [...eCommerceRoutes, ...bouyguesInStoreRoutes, ...giftCardRoutes()]
}
